import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Btn, Eyebrow } from "../components/Primitives";
import { accountsApi, formatAuthError } from "../lib/accountsApi";
import AppShell from "../components/AppShell";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await accountsApi.forgotPassword(email.trim());
            setSent(true);
            toast.success("Check your inbox");
        } catch (err) {
            // Always shown as success on server side — but if rate-limited etc, show error
            toast.error(formatAuthError(err?.response?.data?.detail));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AppShell>
            <div className="flex-1 flex flex-col px-7 py-10" data-testid="forgot-password-screen">
                <Eyebrow>Forgot password</Eyebrow>
                <h1 className="mt-2 font-display text-4xl text-burgundy leading-tight">
                    We'll <span className="italic">email you</span> a reset link.
                </h1>
                <p className="mt-3 text-sm text-ink-muted">
                    Enter the email you registered with. If we find an account, you'll get a one-hour reset link.
                </p>

                {sent ? (
                    <div className="mt-7 p-5 bg-cream-soft border border-burgundy/15" data-testid="forgot-sent">
                        <div className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Sent</div>
                        <p className="mt-2 font-display italic text-xl text-burgundy">Check your inbox.</p>
                        <p className="mt-2 text-sm text-ink-muted">
                            If an account exists for <strong>{email}</strong>, you'll receive a password reset link within a minute. It expires in 1 hour.
                        </p>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-7 space-y-4">
                        <label className="block">
                            <div className="text-[10px] tracking-[0.32em] uppercase text-ink-muted mb-1.5">Email</div>
                            <input
                                data-testid="forgot-email"
                                type="email"
                                autoComplete="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                className="w-full bg-cream-soft border border-burgundy/20 focus:border-burgundy py-3 px-3 text-base text-ink focus:outline-none"
                            />
                        </label>
                        <Btn data-testid="forgot-submit" type="submit" disabled={submitting || !email}>
                            {submitting ? "Sending…" : "Send reset link"}
                        </Btn>
                    </form>
                )}

                <div className="mt-6 text-center">
                    <Link to="/login" className="text-[11px] tracking-[0.24em] uppercase text-burgundy underline underline-offset-4">
                        ← Back to sign in
                    </Link>
                </div>
            </div>
        </AppShell>
    );
}
